import {Component, ComponentInterface, h, Host, Prop} from "@stencil/core";
import {Choice} from "../../../../../utils/backend/reply-parsed"

@Component({
    tag: "c-form-dropdown",
    styleUrl: "c-form-dropdown.scss",
})

export class CFormDropdown implements ComponentInterface {
    @Prop() elements: Choice[];
    @Prop() formName: string;
    @Prop() germanTitle?: string;
    @Prop() theme?: string;

    render() {
        return (
            <Host>
                <div class="dropdown">
                    <label
                        class="dropdown-label"
                        innerHTML={this.formName}
                        data-german={this.germanTitle}
                    />
                    <div class={`form-dropdown ${this.theme ? this.theme : ""}`}>
                        <select id={this.formName} name={this.formName}>
                        {this.elements.map((choice: Choice) => {
                            return (
                                <option value={choice.title}>{choice.title}</option>
                            )
                        })}
                        </select>
                    </div>
                </div>
            </Host>
        )
    }
}
